'use client';

import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

const PrestadorForm = ({
  formData,
  setFormData,
  categories,
  subcategories,
  cities,
  neighborhoods,
  communities,
}) => {
  const setField = (field) => (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({ ...formData, [field]: value });
  };

  const handleCategoryChange = (e) => {
    setFormData({
      ...formData,
      category_id: Number(e.target.value) || '',
      subcategory_id: '',
    });
  };

  const handleCityChange = (e) => {
    setFormData({
      ...formData,
      city_id: Number(e.target.value) || '',
      neighborhood_id: '',
      community_id: '',
    });
  };

  const filteredSubs = formData.category_id ? subcategories : [];
  const filteredNeighborhoods = formData.city_id ? neighborhoods : [];

  return (
    <Form>
      <Row className="g-3">

        {/* Nome / Telefone / Email */}
        <Col md={6}>
          <Form.Group>
            <Form.Label>Nome *</Form.Label>
            <Form.Control value={formData.name} onChange={setField('name')} />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Telefone *</Form.Label>
            <Form.Control value={formData.phone} onChange={setField('phone')} />
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group>
            <Form.Label>E-mail</Form.Label>
            <Form.Control type="email" value={formData.email} onChange={setField('email')} />
          </Form.Group>
        </Col>

        {/* Categoria / Subcategoria */}
        <Col md={6}>
          <Form.Group>
            <Form.Label>Categoria *</Form.Label>
            <Form.Select value={String(formData.category_id || '')} onChange={handleCategoryChange}>
              <option value="">Selecione…</option>
              {categories.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Subcategoria</Form.Label>
            <Form.Select
              value={String(formData.subcategory_id || '')}
              onChange={setField('subcategory_id')}
            >
              <option value="">Selecione…</option>
              {filteredSubs.map((s) => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {/* Cidade / Bairro / Condomínio */}
        <Col md={4}>
          <Form.Group>
            <Form.Label>Cidade *</Form.Label>
            <Form.Select value={String(formData.city_id || '')} onChange={handleCityChange}>
              <option value="">Selecione…</option>
              {cities.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Bairro</Form.Label>
            <Form.Select
              value={String(formData.neighborhood_id || '')}
              onChange={setField('neighborhood_id')}
              disabled={!formData.city_id}
            >
              <option value="">Selecione…</option>
              {filteredNeighborhoods.map((n) => (
                <option key={n.id} value={n.id}>{n.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Condomínio</Form.Label>
            <Form.Select
              value={String(formData.community_id || '')}
              onChange={setField('community_id')}
            >
              <option value="">Selecione…</option>
              {communities.map((c) => (
                <option key={c.id} value={c.id}>{c.name}</option>
              ))}
            </Form.Select>
          </Form.Group>
        </Col>

        {/* Apartamento / Torre */}
        <Col md={6}>
          <Form.Group>
            <Form.Label>Apartamento</Form.Label>
            <Form.Control value={formData.apartment} onChange={setField('apartment')} />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Torre / Bloco</Form.Label>
            <Form.Control value={formData.tower} onChange={setField('tower')} />
          </Form.Group>
        </Col>

        {/* Website / Instagram */}
        <Col md={6}>
          <Form.Group>
            <Form.Label>Website</Form.Label>
            <Form.Control value={formData.website} onChange={setField('website')} />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Instagram</Form.Label>
            <Form.Control value={formData.instagram} onChange={setField('instagram')} />
          </Form.Group>
        </Col>

        {/* CPF / CNPJ */}
        <Col md={6}>
          <Form.Group>
            <Form.Label>CPF / CNPJ</Form.Label>
            <Form.Control value={formData.cpf_cnpj} onChange={setField('cpf_cnpj')} />
          </Form.Group>
        </Col>

        {/* Checkboxes - agrupados lado a lado */}
        <Col md={6} className="d-flex flex-column justify-content-end">
          <Form.Check
            type="checkbox"
            label="Mora no condomínio"
            checked={formData.morar_no_condominio}
            onChange={setField('morar_no_condominio')}
          />
          <Form.Check
            type="checkbox"
            label="Atende em casa"
            checked={formData.atende_em_casa}
            onChange={setField('atende_em_casa')}
          />
          <Form.Check
            type="checkbox"
            label="Selo Conexxi"
            checked={formData.has_connexi_seal}
            onChange={setField('has_connexi_seal')}
          />
          <Form.Check
            type="checkbox"
            label="Patrocinado"
            checked={formData.sponsored}
            onChange={setField('sponsored')}
          />
        </Col>

        {/* Data de início / Criado por */}
        <Col md={6}>
          <Form.Group>
            <Form.Label>Data de início</Form.Label>
            <Form.Control
              type="date"
              value={formData.data_de_inicio}
              onChange={setField('data_de_inicio')}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Criado por (ID)</Form.Label>
            <Form.Control value={formData.created_by} onChange={setField('created_by')} />
          </Form.Group>
        </Col>

        {/* Descrição */}
        <Col xs={12}>
          <Form.Group>
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.description}
              onChange={setField('description')}
            />
          </Form.Group>
        </Col>

      </Row>
    </Form>
  );
};

export default PrestadorForm;
